module.exports = __webpack_public_path__ + "static/media/appa.5a7f3f7a.jpg";